import { createFileRoute } from "@tanstack/react-router";
import ContainerInset from "@/components/container-inset";
import PageLayoutRoot, {
  PageLayoutContent,
  PageLayoutHeader,
} from "@/components/page-layout";
import { useMerchantProvider } from "@/app/(authenticated)/_providers/merchant-provider";
import MerchantDefinedFieldsForm from "../_components/merchant-defined-fields-form";

export const Route = createFileRoute(
  "/(authenticated)/$merchantId/merchant-defined-fields/add/"
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { selectedMerchant } = useMerchantProvider();
  return (
    <ContainerInset
      breadcrumbs={[
        {
          title: "Merchant Defined Fields",
          href: `/${selectedMerchant?.merchAccountId}/merchant-defined-fields`,
        },
        {
          title: "Add",
          href: "#",
        },
      ]}
    >
      <PageLayoutRoot>
        <PageLayoutHeader
          title="Add New Merchant Defined Fields"
          description="To configure this field, first choose a name, followed by the type of field you wish to use. 'Text' is the default and permit any text entry. 'Checkbox' is either on or off corresponding to a Yes or No value. 'Radio' and 'Select' provide discrete option from a list of values you choose to provide"
        />

        <PageLayoutContent>
          <MerchantDefinedFieldsForm />
        </PageLayoutContent>
      </PageLayoutRoot>
    </ContainerInset>
  );
}
